export default "__VITE_ASSET__Cgf6ZVXI__"